import styled, {css} from 'styled-components';

export const ShowcaseContentWrapperDefaultBox = styled.div<{isOpen?: boolean}>`
    grid-column: 1/-1;
    border-block-start: 1px solid ${({theme}) => theme.colors.backgroundContrast};
    padding-block-start: 1rem;

    ${props => props.isOpen 
        ? css`
            height: auto;
            overflow: visible;`
        : css`
            height: 1px;
            overflow: hidden;`
}
`;